import type { ReactNode } from 'react';
import { Button, type ButtonProps } from '@/components/ui/button';
import { cn } from '@/lib/utils';

export function FlatfinderToolbarButton({
  icon,
  label,
  className,
  children,
  ...buttonProps
}: ButtonProps & { icon: ReactNode; label?: string }) {
  return (
    <Button
      {...buttonProps}
      className={cn(
        'size-14 shrink-0 p-1 lg:px-1 [&_svg]:size-5',
        label && 'flex-col gap-1.5',
        className
      )}
    >
      {icon}
      {label ? <span className="text-[0.5625rem] leading-none">{label}</span> : children}
    </Button>
  );
}
